import { parse as parseContentType } from 'content-type';
import isLocal from './is-local';
var makeAjaxRequest = function (url, httpRequestWithCredentials, callback) {
    var httpRequest = new XMLHttpRequest();
    httpRequest.onreadystatechange = function () {
        try {
            if (!/\.svg/i.test(url) && httpRequest.readyState === 2) {
                var contentType = httpRequest.getResponseHeader('Content-Type');
                if (!contentType) {
                    throw new Error('Content type not found');
                }
                var type = parseContentType(contentType).type;
                if (!(type === 'image/svg+xml' || type === 'text/plain')) {
                    throw new Error("Invalid content type: ".concat(type));
                }
            }
            if (httpRequest.readyState === 4) {
                if (httpRequest.status === 404 || httpRequest.responseXML === null) {
                    throw new Error(isLocal()
                        ? 'Note: SVG injection ajax calls do not work locally without ' +
                            'adjusting security settings in your browser. Or consider ' +
                            'using a local webserver.'
                        : 'Unable to load SVG file: ' + url);
                }
                if (httpRequest.status === 200 ||
                    (isLocal() && httpRequest.status === 0)) {
                    callback(null, httpRequest);
                }
                else {
                    throw new Error('There was a problem injecting the SVG: ' +
                        httpRequest.status +
                        ' ' +
                        httpRequest.statusText);
                }
            }
        }
        catch (error) {
            httpRequest.abort();
            if (error instanceof Error) {
                callback(error, httpRequest);
            }
            else {
                throw error;
            }
        }
    };
    httpRequest.open('GET', url);
    httpRequest.withCredentials = httpRequestWithCredentials;
    if (httpRequest.overrideMimeType) {
        httpRequest.overrideMimeType('text/xml');
    }
    httpRequest.send();
};
export default makeAjaxRequest;
//# sourceMappingURL=make-ajax-request.js.map